import AlertCircle from 'assets/icons/alert-circle.svg'
import { FC } from 'react'

import * as Styled from './styles'

type Props = {
  messages?: string | string[]
  type?: 'primary' | 'secondary' | 'success' | 'danger'
}

const AlertContainer: FC<Props> = ({ messages, type }) => {
  return (
    <Styled.MessagesContainer variant={type}>
      <Styled.AlertCircle src={AlertCircle} />
      {messages &&
        [messages].flat().map((msg, idx) => (
          <div key={idx} style={{ marginLeft: '10px' }}>
            <div>{msg}</div>
          </div>
        ))}
    </Styled.MessagesContainer>
  )
}

AlertContainer.displayName = 'AlertContainer'

export default AlertContainer
